import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ViewChild,
    ElementRef,
    AfterViewInit,
    HostListener,
    Input,
    ChangeDetectorRef,
    Output,
    EventEmitter,
    OnChanges
} from '@angular/core';
import * as pickadate from 'pickadate';

import {isChildOf} from '../../../utilities/html.utilities';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class DatepickerComponent implements OnInit, AfterViewInit, OnChanges {
    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;
    @ViewChild('datepicker') datepicker: ElementRef<HTMLElement>;

    @Input() date: Date = new Date();

    @Output() dateChanged: EventEmitter<Date> = new EventEmitter();

    picker: {
        getValue: () => string;
        setSelected: (payload: {
            value: Date;
        }) => void;
    };
    visible: boolean = false;

    constructor(
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.picker = pickadate.create({
            selected: this.date
        });

        this.datepicker.nativeElement.addEventListener('pickadate:change', () => {
            this.date = new Date(this.picker.getValue());
            this.changeDetectorRef.detectChanges();

            this.dateChanged.emit(this.date);
        });

        pickadate.render(this.datepicker.nativeElement, this.picker);

        this.datepicker.nativeElement.remove();
    }

    ngOnChanges() {
        if (!this.picker) {
            return;
        }

        this.picker.setSelected({
            value: this.date
        });
    }

    toggle(e?: Event) {
        if (e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }

        this.visible = !this.visible;

        if (this.visible) {
            this.wrapper.nativeElement.appendChild(this.datepicker.nativeElement);
        } else {
            this.datepicker.nativeElement.remove();
        }
    }

    @HostListener('window:click', ['$event.target'])
    onClick(target: HTMLElement) {
        if (!this.visible) {
            return;
        }

        if (target !== this.datepicker.nativeElement && !isChildOf(this.datepicker.nativeElement, target)) {
            this.toggle();
        }
    }

    get day(): number {
        if (!this.date) {
            return;
        }

        return this.date.getDate();
    }

    get dayString(): string {
        switch (this.date.getDay()) {
            case 0:
                return 'sunday';
            case 1:
                return 'monday';
            case 2:
                return 'tuesday';
            case 3:
                return 'wednesday';
            case 4:
                return 'thursday';
            case 5:
                return 'friday';
            case 6:
                return 'saturday';
        }
    }
}
